import { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { employeesApi } from "../../../api/employeesApi";
import { SingleEmployeeType } from "../../../types/employeeType";
import AbsencePage from "./AbsencePage";

const AbsenceEmployeeEntriesPage = () => {
  const { t } = useTranslation();
  const { serviceModuleId, employeeId } = useParams<{ serviceModuleId: string; employeeId: string }>();
  const parsedServiceModuleId = Number(serviceModuleId);
  const [employee, setEmployee] = useState<SingleEmployeeType | null>(null);

  useEffect(() => {
    if (!employeeId) return;
    const fetchEmployee = async () => {
      const result = await employeesApi.getEmployeeById(employeeId);
      if (result.success() && result.result) {
        setEmployee(result.result);
      } else {
        setEmployee(null);
      }
    };
    fetchEmployee();
  }, [employeeId]);

  const title = useMemo(() => {
    if (!employee) {
      return t("serviceModulesPage.absencePage.employeeEntriesTitleFallback");
    }
    return t("serviceModulesPage.absencePage.employeeEntriesTitle", {
      name: `${employee.firstName} ${employee.lastName}`,
    });
  }, [employee, t]);

  const breadcrumbs = useMemo(
    () => [
      {
        title: "serviceModulesPage.serviceModules",
        link: "serviceModules",
      },
      {
        title,
        link: `serviceModules/absence/${serviceModuleId}/employee/${employeeId}`,
      },
    ],
    [employeeId, serviceModuleId, title]
  );

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs} title={title} />
      <Box sx={{ mt: 3 }}>
        <AbsencePage
          serviceModuleId={Number.isFinite(parsedServiceModuleId) ? parsedServiceModuleId : -1}
          hidePageTitle
          fixedEmployeeId={employeeId}
          hideEmployeeFilter
          hideCalendar
        />
      </Box>
    </>
  );
};

export default AbsenceEmployeeEntriesPage;
